import React from 'react'
import foodOnDemandLogo from '../../assets/images/fodc/image 63.png'
import locationPin from '../../assets/images/fodc/icon-park-outline_local-pin.svg'
import externalRefIconBig from '../../assets/images/fodc/Vector (1).svg'

const Section5 = () => {
  return (
    <div className='fodc-s5'>
        <div className='fodc-s5-wrap'>
            <div className='text-end'>
                <img className='fod-logo' src={foodOnDemandLogo} alt='food-on-demand-logo' />
            </div>
            <p className='text-white w-50 fodc-p-text'>Meet Us at the Food On Demand Conference</p>
            <div className='d-flex gap-3 align-items-start mt-4'>
                <img className='location-pin' src={locationPin} alt='location-pin-icon' />
                <p className='fodc-fs-24 text-white'>Bellagio, Las Vegas | May 5-7, 2025</p>
            </div>
            <div className='d-flex justify-content-between n-d-flex-m'>
                <p className='fodc-sm-text text-white w-50' style={{opacity:'50%'}}>We're live at the event—let's talk ops, finance, and boosting your restaurant profits on delivery apps!</p>
                <img className='ext-ref-ico-big' src={externalRefIconBig} alt='external-ref-icon-big' />
            </div>
        </div>
    </div>
  )
}

export default Section5